import { storeCreator } from '@/utils/store/store.utils';

interface State {
  modalVisible: boolean;
  onSubmit: () => void;
  additionalAction?: () => void;
  handleSetOnSubmit: (onSubmit: State['onSubmit']) => void;
  handleSetAdditionalAction: (additionalAction: State['additionalAction']) => void;
  handleChangeVisibility: (value: boolean) => void;
  handleReset: () => void;
}

export const useStore = storeCreator<State>((set) => ({
  modalVisible: false,
  onSubmit: () => {},
  additionalAction: () => {},

  handleChangeVisibility: (value) => set((state) => ({
    ...state,
    modalVisible: value,
  })),

  handleSetOnSubmit: (onSubmit) => set((state) => ({
    ...state,
    onSubmit,
  })),

  handleSetAdditionalAction: (additionalAction) => set((state) => ({
    ...state,
    additionalAction,
  })),

  handleReset: () => set((state) => ({
    ...state,
    onSubmit: () => {},
    additionalAction: () => {},
  })),
}));
